import { z } from "zod";

const PHONE_RE = /^\+?[0-9\s()/-]{6,25}$/;

const name = z.string().trim().min(2, "Bitte geben Sie Ihren Namen an.").max(100, "Bitte maximal 100 Zeichen.");
const phone = z.string().trim().min(1, "Bitte geben Sie Ihre Telefonnummer an.").regex(PHONE_RE, "Bitte geben Sie eine gültige Telefonnummer an.");
const optionalPhone = z.string().trim().refine((v) => !v || PHONE_RE.test(v), "Bitte geben Sie eine gültige Telefonnummer an.");
const email = z.string().trim().min(1, "Bitte geben Sie Ihre E-Mail-Adresse an.").email("Bitte geben Sie eine gültige E-Mail-Adresse an.");
const consent = z.boolean().refine((v) => v === true, "Bitte stimmen Sie der Datenschutzerklärung zu.");
const optional = (max) => z.string().trim().max(max, `Bitte maximal ${max} Zeichen.`).optional();

export const callbackSchema = z
  .object({
    name,
    phone,
    callback_time: z.enum(["sofort", "heute", "termin"], { errorMap: () => ({ message: "Bitte wählen Sie eine Wunschzeit." }) }),
    callback_at: z.string().optional(),
    concern: z.string().optional(),
    consent,
    website: z.string().optional(),
  })
  .superRefine((d, ctx) => {
    if (d.callback_time === "termin" && !d.callback_at) {
      ctx.addIssue({ code: "custom", path: ["callback_at"], message: "Bitte wählen Sie Datum und Uhrzeit." });
    }
  });

export const emailSchema = z.object({
  name,
  email,
  phone: optionalPhone,
  service: z.string().optional(),
  message: z.string().trim().min(10, "Bitte beschreiben Sie Ihr Anliegen (mind. 10 Zeichen).").max(3000, "Bitte maximal 3000 Zeichen."),
  consent,
  website: z.string().optional(),
});

export const damageSchema = z.object({
  name,
  phone,
  email,
  cause: z.string().min(1, "Bitte wählen Sie die Schadenursache."),
  plz: z.string().trim().regex(/^\d{5}$/, "Bitte geben Sie eine 5-stellige PLZ an."),
  plate: optional(15),
  accident_date: z.string().optional(),
  drivable: z.string().nullable().optional(),
  opponent_insurance: optional(100),
  consent,
  website: z.string().optional(),
});
